export const conceptOptions = [
    { value: "ISR", label: "ISR" },
    { value: "IVA", label: "IVA" },
    { value: "IEPS", label: "IEPS" },
    { value: "MULTAS", label: "MULTAS" },
    { value: "3% NÓMINA", label: "3% NÓMINA" },
    { value: "CUOTAS OBRERO PATRONALES", label: "CUOTAS OBRERO PATRONALES" },
    { value: "Otros", label: "Otros" },
];
